import { atom } from 'jotai'
import { nation } from './nation';

export const nationsAtom = atom([] as nation[]);